@use "~theme/breakpoints";
@use "~theme/typography" as typography;

.patientSpace {
  margin-top: 10px;
}

@mixin two-columns {
  display: flex;
  flex-direction: row;
  align-items: flex-start;

  > * {
    flex: 1;
    margin-left: 8px;
  }

  > :first-child {
    margin-left: 0;
    margin-right: 8px;
  }
}
.dob {
  > :first-child {
    margin-right: 0px !important;
  }
}
.header {
  @include typography.heading3;
  margin-bottom: 10px;
}

.container {
  background-color: var(--white);
  padding: var(--mobile-gutter);
  flex-grow: 1;
  max-width: var(--max-desktop-width);
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  box-shadow: 0 2px 6px var(--gray03);

  @include breakpoints.desktop {
    margin-top: auto;
    margin-bottom: auto;
  }
}

.form {
  display: flex;
  flex: 1;
  flex-direction: column;
}

.buttons {
  display: flex;
  flex-direction: row;
  flex: 1;
  align-items: flex-end;

  > :last-child {
    margin-right: 0;
  }

  > :first-child {
    margin-left: 0;
  }
}

.button {
  margin: 0 8px;
}

.twoColumns {
  @include two-columns;

  @include breakpoints.desktop {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1.12fr);
    column-gap: 16px;

    > * {
      margin-left: 0;
    }

    > :first-child {
      margin-right: 0;
    }
  }
  
  input {
    @include breakpoints.desktop {
      //width: 400px;
    }
  }
}

.desktopTwoColumns {
  @include breakpoints.desktop {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1.12fr);
    column-gap: 16px;

    > * {
      margin-left: 0;
    }

    > :first-child {
      margin-right: 0;
    }
  }

  input {
    @include breakpoints.desktop {
      //width: 400px;
    }
  }
}

.smsHelp {
  @include typography.caption;
  margin: 0 0 24px;
  color: var(--black-at-75);

  a {
    color: var(--black-at-75);
  }
}

.agreeText {
  color: var(--black-at-75); 
}

.tooltipHavingError {
  margin-bottom: 44px;

  @include breakpoints.desktop {
    margin-bottom: 0;
  }
}

.tooltipText {
  margin: 0;
}

.layout {
  padding: 24px 24px 12px;
  background-color: #ffffff;
  border-radius: 20px;
  margin: 10px;
  margin-top: 30px;
  height: auto;
  position: relative;

  @include breakpoints.desktop {
    min-height: 512px;
    gap: 32px;
    opacity: 1;
    border-radius: 20px;
    padding: 32px;
    padding-bottom: 27px;
    margin: 20px;
    overflow: visible;
    background-color: #ffffff;
    border-bottom: 1px solid #CAC6C6;
  }

  p {
    min-height: 0px;
    @include breakpoints.desktop {
     // min-height: 43.2px;
    }
  }
}

.formContainer {
  @include breakpoints.desktop {
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 100%;
    max-width: 820px;
    min-height: 375px;
    padding-right: 0;
  }
}

.layout {
  > label {
    @include breakpoints.desktop {
      width: 100%;
      max-width: calc(100% - 450px);
    }
  }
}

.headline {
  font-family: "Instrument Serif";
  font-weight: 400;
  font-style: normal;
  font-size: 32px;
  line-height: 100%;
  letter-spacing: 0%;
  vertical-align: middle;
  color: var(--brand-indigo);
  text-transform: none;
  margin: 0;

  @include breakpoints.desktop {
    margin-bottom: 0px;
  }
}

.divider {
  border-bottom: 1px solid var(--brand-indigo);
  margin-bottom: 15px;
  width: 160px;
  margin-left: 0px;

  @include breakpoints.desktop {
    @include typography.heading3;
    display: block;
    margin: 0px;
    border: none;
    border-bottom: 1px solid var(--brand-indigo);
    width: 8em;
  }
}

.actionSlot {
  margin-top: 24px;
  display: flex;
  justify-content: center;

  @include breakpoints.desktop {
    position: absolute;
    right: 32px;
    bottom: 51px;
    margin-top: 0;
    justify-content: flex-end;
  }
}

.asterisk {
  color: var(--brand-indigo);
}
